import React from 'react';
import PropTypes from 'prop-types';

const ModuleHeader = ({
  noSlug,
  slugName,
  adIsPlaying,
  videoTitle,
  hideMobileVideoPlayer
}) => (
  <div className="mobile-video-module-header">
    {!noSlug && <div className="component-slug">{slugName}</div>}

    <div className="video-title">
      {adIsPlaying && <span>Next: </span>}
      {videoTitle}
    </div>
    <div
      className="close-button"
      onClick={() => {
        hideMobileVideoPlayer();
      }}
    >
      <img
        src="https://assets.fastcompany.com/multisite_files/fastcompany/static/icons/mvp-close-button_new.svg"
        alt="close"
      />
    </div>
  </div>
);

ModuleHeader.defaultProps = {
  noSlug: false,
  slugName: '',
  adIsPlaying: false,
  videoTitle: '',
  hideMobileVideoPlayer: () => {}
};

ModuleHeader.propTypes = {
  noSlug: PropTypes.bool,
  slugName: PropTypes.string,
  adIsPlaying: PropTypes.bool,
  videoTitle: PropTypes.string,
  hideMobileVideoPlayer: PropTypes.func
};

export default ModuleHeader;
